export const ROLES = {
    ADMIN: "ADMIN",
    MEMBER: "MEMBER",
    VIEWER: "VIEWER",
    UNAUTHORIZED: "UNAUTHORIZED",
};

export const DASHBOARD_ALLOWED_ROLES = [ROLES.ADMIN, ROLES.MEMBER];

export const INTERNAL_KB_ALLOWED_ROLES = [ROLES.ADMIN, ROLES.MEMBER, ROLES.VIEWER];

export const KB_TYPE = {
    INTERNAL: 'internal',
    EXTERNAL: 'external',
}

export const FEATURE_FLAG_NEW_AUTH = "rls-newauth-kb-service";
export const GMAIL_SEARCH_PLACEHOLDER = "in Gmail";
export const OMNI_SEARCH_PLACEHOLDER = "Omni";
export const HIVER_GMAIL = "Hiver in Gmail";
export const HIVER_OMNI = "Hiver Omni";
export const OUTLOOK_PRODUCT_TYPE = "hiver-for-outlook";
export const OMNI_PRODUCT_TYPE = "hiver-omni";
export const NAVIGATION_BUTTON_TEXT = "Go to {{product}}";
export const SEARCH_PLACEHOLDER = "Search across Hiver {{product}}";
